import { render, staticRenderFns } from "./InvoiceSituation.vue?vue&type=template&id=6bc157a7&scoped=true"
import script from "./InvoiceSituation.vue?vue&type=script&lang=js"
export * from "./InvoiceSituation.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSituation.vue?vue&type=style&index=0&id=6bc157a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc157a7",
  null
  
)

export default component.exports